import { TitleCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  output,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { SmsDto, SmsStatus } from '@workspace/data-types';
import { AlertSnackBarService, AvatarAuraComponent, LuxonDatePipe } from '@workspace/ng-aura';
import { SmsActionDisplayPipe, SmsStatusDisplayPipe, SmsTagDisplayPipe } from '@workspace/ng-data-access';
import { ApiService } from '@workspace/ng-http';
import { catchError, finalize, of, tap } from 'rxjs';

@Component({
  selector: 'core-sms-details',
  templateUrl: './sms-details.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatTooltipModule,
    LuxonDatePipe,
    SmsActionDisplayPipe,
    SmsStatusDisplayPipe,
    SmsTagDisplayPipe,
    RouterModule,
    TitleCasePipe,
    AvatarAuraComponent,
  ],
})
export class SmsDetailsCoreComponent {
  private readonly apiService = inject(ApiService);
  private readonly alertSnackBar = inject(AlertSnackBarService);
  private readonly destroyRef = inject(DestroyRef);

  sms = input.required<SmsDto>();
  smsUpdated = output<SmsDto>();

  readonly smsStatus = SmsStatus;
  readonly isResending = signal(false);

  onResend(): void {
    if (this.isResending()) return;
    this.isResending.set(true);
    this.apiService
      .admin()
      .sms()
      .resend(this.sms()._id)
      .pipe(
        tap((updatedSms) => {
          this.alertSnackBar.success({ message: "Nouvelle tentative d'envoi effectuée !" });
          this.smsUpdated.emit(updatedSms);
        }),
        catchError((err) => {
          this.alertSnackBar.error({
            message: 'Échec du renvoi du SMS : ' + (err?.message || 'Erreur inconnue'),
          });
          return of(null);
        }),
        finalize(() => this.isResending.set(false)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
